import React from 'react'
import './pricing.css'

import { Card } from '../../components'

const Pricing = () => {
  return (
    <div className="pricing__container section__padding">
      <div className="pricing__header">
        <div>
          <h2>Pricing Plans</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Elementum nisi aliquet volutpat pellentesque volutpat est.
          </p>
        </div>
      </div>
      <div className="pricing__container-cards">
        <Card 
          type='Starter'
          userNumber='3'
          price='29'
        />
        <Card 
          type='Standard'
          userNumber='20'
          price='99'
        />
        <Card 
          type='Premium'
          userNumber='200'
          price='299'
        />
      </div>
    </div>

  )
}

export default Pricing
